import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href", "target", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_card = _resolveComponent("q-card");
    const _component_pic_set = _resolveComponent("pic-set");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["row", _ctx.parsedContainerClass]),
        ref: "root",
        style: _normalizeStyle(_ctx.containerStyle),
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
    }, [
        (!_ctx.srcImage)
            ? (_openBlock(), _createBlock(_component_q_card, {
                key: 0,
                class: _normalizeClass([{
                        ..._ctx.picClass
                    }, "text-center q-mr-none bg-transparent"]),
                style: _normalizeStyle(_ctx.picStyle),
                flat: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.picClass),
                        style: _normalizeStyle({
                            'height': _ctx.height || '',
                            'vertical-align': 'bottom'
                        })
                    }, null, 6)
                ]),
                _: 1
            }, 8, ["class", "style"]))
            : (_ctx.routerWrap && (_ctx.appMode === _ctx.targetApp))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { name: _ctx.pathName, params: _ctx.pathParams, query: _ctx.pathQueries },
                    custom: ""
                }, {
                    default: _withCtx(({ href, navigate }) => [
                        _createElementVNode("a", {
                            href: href,
                            target: _ctx.target,
                            class: _normalizeClass({
                                'disable-route': _ctx.routeDisabled
                            }),
                            onClick: navigate
                        }, [
                            _createVNode(_component_pic_set, {
                                "webp-src-set": _ctx.sizeType ? _ctx.srcSets.webp : _ctx.webp,
                                "original-src-set": _ctx.srcSets.original,
                                "original-src": _ctx.original,
                                "pic-class": _ctx.picClass,
                                "pic-style": _ctx.picStyle,
                                "image-style": {
                                    ...(_ctx.height
                                        ? {
                                            'height': _ctx.height
                                        } : {}),
                                    'vertical-align': 'bottom'
                                },
                                sizes: _ctx.componentSize,
                                draggable: _ctx.draggable,
                                ratio: _ctx.ratio,
                                "custom-width": _ctx.customWidth,
                                "custom-height": _ctx.customHeight,
                                "default-loaded": _ctx.preloaded,
                                "allow-other-formats": _ctx.allowOtherFormats,
                                alternative: _ctx.alternative,
                                "alternative-src-set": _ctx.alternativeSrcSet,
                                "alternative-webp-src-set": _ctx.alternativeWebpSrcSet,
                                alt: _ctx.alt,
                                centered: _ctx.centered,
                                onLoad: _ctx.loadEmitter,
                                "show-load": _ctx.showLoad,
                                id: "pic-set"
                            }, null, 8, ["webp-src-set", "original-src-set", "original-src", "pic-class", "pic-style", "image-style", "sizes", "draggable", "ratio", "custom-width", "custom-height", "default-loaded", "allow-other-formats", "alternative", "alternative-src-set", "alternative-webp-src-set", "alt", "centered", "onLoad", "show-load"])
                        ], 10, _hoisted_1)
                    ]),
                    _: 1
                }, 8, ["to"]))
                : (_openBlock(), _createBlock(_component_pic_set, {
                    key: 2,
                    "webp-src-set": _ctx.sizeType ? _ctx.srcSets.webp : _ctx.webp,
                    "original-src-set": _ctx.srcSets.original,
                    "original-src": _ctx.original,
                    "pic-class": _ctx.picClass,
                    "pic-style": _ctx.picStyle,
                    "image-style": {
                        ...(_ctx.height
                            ? {
                                'height': _ctx.height
                            } : {}),
                        'vertical-align': 'bottom'
                    },
                    sizes: _ctx.componentSize,
                    draggable: _ctx.draggable,
                    ratio: _ctx.ratio,
                    "custom-width": _ctx.customWidth,
                    "custom-height": _ctx.customHeight,
                    "default-loaded": _ctx.preloaded,
                    "allow-other-formats": _ctx.allowOtherFormats,
                    alternative: _ctx.alternative,
                    "alternative-src-set": _ctx.alternativeSrcSet,
                    "alternative-webp-src-set": _ctx.alternativeWebpSrcSet,
                    alt: _ctx.alt,
                    centered: _ctx.centered,
                    onLoad: _ctx.loadEmitter,
                    "show-load": _ctx.showLoad,
                    id: "pic-set"
                }, null, 8, ["webp-src-set", "original-src-set", "original-src", "pic-class", "pic-style", "image-style", "sizes", "draggable", "ratio", "custom-width", "custom-height", "default-loaded", "allow-other-formats", "alternative", "alternative-src-set", "alternative-webp-src-set", "alt", "centered", "onLoad", "show-load"])),
        _renderSlot(_ctx.$slots, "items")
    ], 6));
}
